import React, { useState } from "react";
import { styled, SxProps, Stack, IconButton } from "@mui/material";
import PosterImage from "../../Misc/PosterImage";
import { GetFrameRate, ReactPlayerMarker } from "../../../Redux/Reducers/redux-slice-react-player";
import { JWPMarkerTimecode } from "../../../Utils/Timecode/ReactPlayer";
import { cacheService, mediaService } from "../../../Core/Api/services";
import { FileDownloadOutlined } from "@mui/icons-material";
import { useAppSelector } from "../../../Redux/redux-store";

export type StoryboardCardProps = {
  className?: string;
  sx?: SxProps;
  objectId: number;
  id: number;
  thumbnail?: string;
  timecodes: { in: ReactPlayerMarker; out: ReactPlayerMarker; frameRate: number };
};

const StoryboardCard: React.FC<StoryboardCardProps> = (props) => {
  const { id, objectId, timecodes, thumbnail, ...otherProps } = props;

  const frameRate = useAppSelector(GetFrameRate);

  const [hover, setHover] = useState(false);

  function handleMouseEnter() {
    setHover(true);
  }
  function handleMouseLeave() {
    setHover(false);
  }

  function handleDownloadFrame() {
    mediaService.GetScreenshotFromAssetVideoProxy(objectId, timecodes.in.markFrame, cacheService.GetAuthKey()!);
  }

  return (
    <Stack sx={{ position: "relative", aspectRatio: "16 / 9" }} {...otherProps}>
      {thumbnail !== undefined && (
        <PreviewMarker
          img={{ src: thumbnail! }}
          sx={{ position: "absolute", left: 0, top: 0, right: 0, bottom: 0 }}
          flexShrink={0}
        />
      )}
      <Stack
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          borderRadius: "6px",
          position: "absolute",
          background: "rgba(0,0,0,0.5)",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          opacity: hover ? 1 : 0,
          backdropFilter: "blur(4px)",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >
        <JWPMarkerTimecode frameRate={frameRate} {...timecodes.in}></JWPMarkerTimecode>
        <IconButton size="small" color="neutral" onClick={handleDownloadFrame}>
          <FileDownloadOutlined />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export const PreviewMarker = styled(PosterImage)(({ theme, img }) => ({
  position: "relative",
  "&:before": {
    content: '""',
    position: "absolute",
    // left: 0,
    // right: 0,
    // bottom: 0,
    // top: 0,
    background: "", //img.src === "" ? "none" : "radial-gradient(86.28% 385.52% at 70.39% 33.17%, rgba(0, 0, 0, 0) 0%, #000000 100%)",
  },
}));

export default StoryboardCard;
